// extracted by mini-css-extract-plugin
export default {"panel":"GeneralTabPanel_panel__5rVyH"};